import Controller from './Controller'
import { trace } from 'rytm-helpers'
import { initMaps } from './../shared/mapsController'
import { scrollToTarget } from './../shared/scrollTo'


class VenueModalMapController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.maps = initMaps()
    this.openMapsInfoWindow()
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    super.onViewHidden(e)
    
  }
  addEventListeners() {
    super.addEventListeners()
  }
  removeEventListeners() {
    super.removeEventListeners()
  }
  /**
   * ###########
   * ### OWN ###
   */
  openMapsInfoWindow() {
    const container = document.querySelector(this.getContainerSelector())
    const id = container ? container.dataset.id : null
    if (id) {
      this.maps.forEach((map) => {
        map.openInfoWindowById(id, 16)
      })
    }
  }
  

}

export default VenueModalMapController;